import { ISpecialtiesFilters } from '@/common/types';

export const HOMEPAGE_TITLE_MAX_LENGTH = 30;
export const HOMEPAGE_DESCRIPTION_MAX_LENGTH = 150;

export const DEFAULT_SPECIALTIES_FILTERS: ISpecialtiesFilters = {
  language: 'en',
  status: '',
};
